<template>
  <div id="app">
    <v-app>
      <Splash v-if="initializing || loading" />
      <components :is="layout" v-else>
        <transition name="fade" mode="out-in">
          <router-view :key="$route.fullPath" />
        </transition>
      </components>
      <v-snackbar v-model="show" :color="color" :timeout="timeout" top right>
        {{ text }}
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import axios from "./modules/axios";
import Splash from "@/views/splash/Splash.vue";
import { mapGetters } from "vuex";
import store from "@/store/index";
import router from "@/router/index";

const default_layout = "default";
export default {
  data: () => ({
    show: false,
    color: "info",
    text: "",
    timeout: 2000,
    loading: true,
    timer: null,
  }),
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    ...mapGetters({
      initializing: "initializing",
      user: "getUser",
    }),
  },
  mounted() {
    firebase.auth().onAuthStateChanged(async (auth) => {
      if (!auth) {
        axios.defaults.headers.common[
          "Authorization"
        ] = null;
        return;
      }
      const accessToken = await auth.getIdToken();
      if (accessToken) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${accessToken}`;
        this.getCredits();
      } else {
        axios.defaults.headers.common[
          "Authorization"
        ] = null;
      }
    });

    this.timer = setTimeout(() => {
      this.loading = false;
    }, 2000);
    if ( !this.user?.plan ) {
      if ( this.$route.path === "/login" || this.$route.path === "/signup" || this.$route.path === "/customer/create" || this.$route.path === "/" ) {
        return
      }
      router.push("/membership");
      return;
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  components: {
    Splash,
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SNACKBAR") {
        this.color = state.snackbar.type;
        this.text = state.snackbar.message;
        this.show = true;
      }
    });
  },
  methods: {
    async getCredits() {
      try {
        const response = await axios.get("credit");
        if (response.data) {
          const userData = {
            ...this.user,
            credit_days: response.data.credit,
            included_miles: response.data.miles,
          };

          store.dispatch({
            type: "updateUser",
            user: userData,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    $route() {
      if ( !this.user?.plan ) {
        if ( this.$route.path === "/login" || this.$route.path === "/signup" || this.$route.path === "/customer/create" ) {
          return
        }
        router.push("/membership");
        return;
      }
    }
  }
};
</script>
<style lang="scss"></style>
